import { DomainRuleError } from "./core";

export const orderCategories = [
  "imaging",
  "laboratory",
  "procedure",
  "medication",
  "therapy",
  "other",
] as const;
export type OrderCategory = (typeof orderCategories)[number];

export const orderDestinations = [
  "radiology",
  "laboratory",
  "treatment_room",
  "pharmacy",
  "physical_therapy",
  "none",
] as const;
export type OrderDestination = (typeof orderDestinations)[number];

export const orderLateralityValues = [
  "left",
  "right",
  "bilateral",
  "not_applicable",
] as const;
export type OrderLaterality = (typeof orderLateralityValues)[number];

export const orderStatuses = [
  "draft",
  "queued",
  "in_progress",
  "completed",
  "cancelled",
] as const;
export type OrderStatus = (typeof orderStatuses)[number];

export const orderModalities = [
  "xray",
  "ct",
  "mri",
  "ultrasound",
  "laboratory",
  "procedure",
  "medication",
  "therapy",
  "other",
] as const;
export type OrderModality = (typeof orderModalities)[number];

export function isOrderCategory(value: unknown): value is OrderCategory {
  return orderCategories.some((candidate) => candidate === value);
}

export function isOrderDestination(value: unknown): value is OrderDestination {
  return orderDestinations.some((candidate) => candidate === value);
}

export function isOrderLaterality(value: unknown): value is OrderLaterality {
  return orderLateralityValues.some((candidate) => candidate === value);
}

export function isOrderStatus(value: unknown): value is OrderStatus {
  return orderStatuses.some((candidate) => candidate === value);
}

export function isOrderModality(value: unknown): value is OrderModality {
  return orderModalities.some((candidate) => candidate === value);
}

export function assertOrderCanBeConfirmed(input: {
  status: OrderStatus;
  requiresLaterality: boolean;
  laterality: OrderLaterality | null;
}): void {
  if (input.status !== "draft") {
    throw new DomainRuleError(
      "INVALID_ORDER_TRANSITION",
      "초안 상태의 오더만 확정할 수 있습니다.",
    );
  }
  if (
    input.requiresLaterality &&
    (input.laterality === null || input.laterality === "not_applicable")
  ) {
    throw new DomainRuleError(
      "ORDER_CONFIRMATION_REQUIRED",
      "좌우 부위를 확인한 뒤 오더를 확정하십시오.",
    );
  }
}

export function normalizeOrderSearch(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase("ko-KR")
    .replace(/[+/_-]+/g, " ")
    .replace(/\s+/g, " ");
}
